import apiHeader from '@/helpers/apiHeader'

const notificationTemplateService = {
    list(params) {
        return apiHeader.get('general-setting/notification-template', { params });
    },
    get(id) {
        return apiHeader.get(`general-setting/notification-template/${id}`);
    },
    create(params) {
        return apiHeader.post('general-setting/notification-template', params);
    },
    update(id, params) {
        return apiHeader.patch(`general-setting/notification-template/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`general-setting/notification-template/${id}`);
    }
    
}

export default notificationTemplateService;
